export const LIST_APPOINTMENTS = 'surgery:listAppointments';
export const CREATE_APPOINTMENT = 'surgery:createAppointment';
export const UPDATE_APPOINTMENT = 'surgery:updateAppointment';
export const DELETE_APPOINTMENT = 'surgery:deleteAppointment';
export const BLOCK_APPOINTMENT = 'surgery:blockAppointment';
export const PRINT_APPOINTMENT_LIST = 'surgery:printAppointmentList';

export default [
  {
    action: LIST_APPOINTMENTS,
    name: 'Agendamentos: Listar',
  },
  {
    action: CREATE_APPOINTMENT,
    name: 'Agendamentos: Criar',
  },
  {
    action: UPDATE_APPOINTMENT,
    name: 'Agendamentos: Atualizar',
  },
  {
    action: DELETE_APPOINTMENT,
    name: 'Agendamentos: Excluir',
  },
  {
    action: BLOCK_APPOINTMENT,
    name: 'Agendamentos: Bloquear',
  },
  {
    action: PRINT_APPOINTMENT_LIST,
    name: 'Agendamentos: Imprimir lista',
  },
];
